import { Col } from 'react-bootstrap';
export default Col;
